module.exports = "<p>\n  <ng-content></ng-content>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty-content/empty-content.component.html
// module id = ../../../../../src/app/shared/empty/empty-content/empty-content.component.html
// module chunks = 4